import { uniqueId } from "lodash";

const downloadFile = (url, documentName = "new File") => {
  fetch(url + "?" + uniqueId("doc_"), {
    method: "GET",
    headers: {
      "Access-Control-Allow-Origin": "*",
    },
  })
    .then((response) => {
      response.arrayBuffer().then((buffer) => {
        const url = URL.createObjectURL(new Blob([buffer]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", documentName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    })
    .catch(() => {});
};

export default downloadFile;
